export const FONTWEIGHT = {
  HEAVY: "700",
  MEDIUM: "600",
};
